export const GET_INFO = 'GET_INFO';

export const GET_UNCONFIRMED_TXS = 'GET_UNCONFIRMED_TXS';
export const GET_SWAPS = 'GET_SWAPS';
export const SWAP_TOKEN = 'SWAP_TOKEN';
export const FINALIZE_SWAP_TOKEN = 'FINALIZE_SWAP_TOKEN';
